import React from 'react'

const CompleteModal = ({CompleteOrder}) => {
  return (
    <div className="uk-modal-dialog" style={{ marginTop: '250px' }} >
    <button className="uk-modal-close-default" type="button" uk-close>X</button>
    <div className="uk-modal-header">
      <h2 className="uk-modal-title">Complete Order</h2>
    </div>
    <div className="uk-modal-body">
      <h4>Are you sure you want to complete this order ?</h4>
    </div>
    <div className="uk-modal-footer uk-text-right">
      <button className="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
      <button className="uk-button uk-button-secondary  " type="button" onClick={CompleteOrder} >Complete</button>
    </div>
  </div>
  )
}

export default CompleteModal